function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M56.1092 16.9926H54.3156V40.2568H56.1092C63.2832 40.2568 65.9991 34.466 65.9991 28.1635C65.9991 21.3993 63.3345 16.9926 56.1092 16.9926Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M57.544 48.0458H45.502V9.30607H57.544C70.2527 9.30607 75.0692 17.9664 75.0692 28.1636C75.0692 38.0532 71.2771 48.0458 57.544 48.0458ZM34.8407 48.2506C32.9447 48.2506 30.5361 48.0455 30.5361 48.0455C30.0754 45.1757 29.409 41.8967 28.7941 39.0269H18.3408C17.7258 41.8452 17.1109 45.2272 16.6496 48.0455C16.6496 48.0455 14.3438 48.2506 11.9868 48.2506C9.68075 48.2506 7.4774 48.0455 7.4774 48.0455C10.7054 32.4166 13.5752 21.7578 18.1871 9.30579C18.1871 9.30579 20.9029 9.10147 23.4139 9.10147C26.1294 9.10147 28.9992 9.30579 28.9992 9.30579C33.6111 21.8093 36.4803 32.3651 39.7089 48.0455C39.7089 48.0455 37.5053 48.2506 34.8407 48.2506ZM69.7006 -3.8147e-06H13.6748C6.12217 -3.8147e-06 0 7.91433 0 17.6774V60.182L12.4753 57.649C12.4753 57.649 13.2623 57.6493 13.6748 57.6493H69.7006C77.2558 57.6493 83.3769 49.7352 83.3769 39.9775V17.6774C83.3769 7.91433 77.2558 -3.8147e-06 69.7006 -3.8147e-06Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.4649 18.5294C22.235 22.4752 21.0054 27.4971 20.0317 31.4431H27.1542C26.1295 27.1385 24.8996 22.4752 23.6701 18.5294H23.4649Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M98.2371 39.8468L109.511 40.3593C109.511 40.3593 109.716 42.5114 109.716 44.4586C109.716 46.4571 109.511 48.1479 109.511 48.1479H88.7576V9.40882C88.7576 9.40882 91.1658 9.20393 93.7792 9.20393C95.8801 9.20393 98.2371 9.40882 98.2371 9.40882V39.8468Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M134.108 28.317C134.108 19.042 132.007 16.6335 127.293 16.6335C122.578 16.6335 120.478 19.042 120.478 28.317C120.478 36.977 122.578 40.7175 127.293 40.7175C132.007 40.7175 134.108 36.977 134.108 28.317ZM111.766 28.317C111.766 13.6616 116.225 8.99849 127.293 8.99849C138.361 8.99849 142.819 13.6616 142.819 28.317C142.819 42.1011 138.361 48.3528 127.293 48.3528C116.225 48.3528 111.766 42.1011 111.766 28.317Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M163.163 8.99878C170.03 8.99878 174.385 12.5859 174.385 12.5859C173.104 15.0454 171.515 17.0441 169.773 18.8884C169.773 18.8884 167.365 16.6338 163.163 16.6338C158.09 16.6338 154.861 18.8377 154.861 28.5737C154.861 38.3611 157.629 40.7178 162.087 40.7178C163.419 40.7178 165.059 40.7693 166.391 40.6157V32.0066H161.011C161.011 32.0066 160.806 30.4179 160.806 28.2148C160.806 26.1139 161.011 24.2691 161.011 24.2691H175V47.3796C170.593 47.9943 167.16 48.3528 162.087 48.3528C151.07 48.3528 146.048 43.6388 146.048 28.5737C146.048 13.5085 151.479 8.99878 163.163 8.99878Z",
  fill: "white"
});

var SvgAdlogLogo = function SvgAdlogLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 61,
    viewBox: "0 0 175 61",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdlogLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/adlog-logo.91e7a15c.svg";
export { ForwardRef as ReactComponent };